module.exports = __webpack_public_path__ + "bin/227339d476defefbb24cb7c20f06fbc1.jpg";